import {combineReducers} from 'redux';
import sidebar from './sidebar/reducer';
import header from './header/reducer';

export default combineReducers({
  sidebar,
  header,
});
